import { Link } from "react-router-dom";
import { heroStats, hotTicker } from "@/mocks/home";

const tickerText = [...hotTicker, ...hotTicker];

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20stylized%20city%20night%20scene%20with%20glowing%20red%20and%20gold%20neon%20light%20streaks%2C%20abstract%20geometric%20shapes%2C%20crowd%20of%20anonymous%20silhouettes%20looking%20at%20screens%2C%20dramatic%20dark%20moody%20atmosphere%2C%20editorial%20poster%20aesthetic%2C%20high%20contrast%2C%20abstract%20not%20photorealistic&width=1600&height=900&seq=baoliao-hero-bg&orientation=landscape"
          alt="爆料大赛评选专区背景，城市夜空与数据光带"
          title="爆料大赛 · 投票评选入口"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />

      <div className="relative w-full px-4 md:px-8 pt-28 pb-16">
        <div className="mx-auto max-w-6xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse-dot" />
            <span className="text-xs md:text-sm text-background-100">第 6 届 · 本轮投票通道开放中</span>
          </div>

          <h1 className="font-heading text-background-50 leading-[1.05] tracking-wide text-5xl md:text-7xl lg:text-8xl">
            爆料大赛
          </h1>
          <p className="mt-4 md:mt-6 text-xl md:text-3xl font-medium text-background-100 max-w-3xl leading-snug">
            群众打分决定排名，你心中的名场面值得被看见
          </p>
          <p className="mt-4 text-sm md:text-base text-background-200 max-w-2xl leading-relaxed">
            进入爆料大赛评选互动专区，查看当前入围名单与群众打分走势，参与投票支持你心中的名场面，实时刷新排名结果与热门候选动态。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/finalists"
              className="px-7 py-3.5 rounded-md bg-primary-500 text-background-50 font-bold text-sm md:text-base text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              进入评选专区投票
            </Link>
            <Link
              to="/ranking"
              className="px-7 py-3.5 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-medium text-sm md:text-base text-center whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              查看实时排名结果
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl">
            {heroStats.map((stat) => (
              <div key={stat.label} className="border-l-2 border-primary-500 pl-4">
                <dt className="text-xs md:text-sm text-background-300">{stat.label}</dt>
                <dd className="mt-1 font-heading text-2xl md:text-3xl text-background-50 tracking-wide">
                  {stat.value}
                  <span className="text-sm ml-1 text-accent-400">{stat.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 border-t border-background-50/15 bg-foreground-950/60 backdrop-blur-sm">
        <div className="flex items-center gap-3 px-4 md:px-8 py-2.5 overflow-hidden">
          <span className="shrink-0 flex items-center gap-1.5 text-xs font-bold text-accent-400">
            <i className="ri-flashlight-fill" />
            动态
          </span>
          <div className="flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee">
              {tickerText.map((text, index) => (
                <span key={`${text}-${index}`} className="px-6 text-xs md:text-sm text-background-200 whitespace-nowrap">
                  {text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}